import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login.vue'),
    meta: { layout: 'blank', requiresAuth: false },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/Dashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    component: () => import('@/pages/CampaignsList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/campaigns/:id',
    name: 'campaign-detail',
    component: () => import('@/pages/Campaigns.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/games',
    name: 'games',
    component: () => import('@/pages/Games.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/submissions',
    name: 'submissions',
    component: () => import('@/pages/Submissions.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/entries',
    name: 'entries',
    component: () => import('@/pages/Entries.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/pages/Users.vue'),
    meta: { requiresAuth: true, requiresRoot: true },
  },
  { path: '/', redirect: '/dashboard' },
  { path: '/:pathMatch(.*)*', redirect: '/campaigns' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  if (to.meta.requiresRoot && auth.user?.role !== 'root') {
    return { name: 'campaigns' };
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'campaigns' };
  }
  return true;
});
